import React from 'react';

import Search from '../smart_component/Search.jsx'

import LogoSite from '../img/LogoSite.png';
import BV from '../img/BV.jpg'
import CDL from '../img/CDL.png'
import dreal from '../img/dreal.png'
import RB from '../img/RB.gif'

export const SiteLogo = ({searchMethod, showConnection, isAdmin}) => {
  return(
    <div id='logo-container'>
      <span >
      {
        isAdmin
        ? <div style={{position: 'absolute', top: 12, left: 12, backgroundColor: 'red', color: 'white', borderRadius: 20, paddingLeft: 5, paddingRight: 5}}>
            Admin
          </div>
        : null
      }
      </span>
      <img height='100%' className='img-contained logo' src={LogoSite} />
      <Search searchMethod={tx => searchMethod(tx)} showConnection={() => showConnection()}/>
      <div style={{ flex: 2, maxHeight: '100%', justifyContent: 'flex-end', marginRight: 10 , paddingTop: 5, paddingBottom: 5}}>

        <img className='logo-partner logo' src={BV} style={{ width: 200, marginRight: 15 }}
          onClick={() => window.open('https://www.bretagne-vivante.org/','_blank')} />
        <img className='logo-partner logo' src={CDL} style={{ width: 250, marginRight: 15}}
          onClick={() => window.open('http://www.conservatoire-du-littoral.fr/','_blank')} />
        <img className='logo-partner logo' src={RB} style={{ width: 150, marginRight: 10 }}
          onClick={() => window.open('https://www.bretagne.bzh/','_blank')} />
        <img className='logo-partner logo' src={dreal} style={{ width: 120 }}
          onClick={() => window.open('http://www.bretagne.developpement-durable.gouv.fr/','_blank')} />
      </div>
    </div>
  )
}